/**
 * Employee Web — `/me/preferences` route (EW-16 partial, D-16).
 *
 * Phase 5 Plan 05-03-04. Ships the employee preferences page inside the
 * /me profile shell. Contains the notification channel grid (Bell/Toast/Email/Push
 * × 6 event types) with auto-save PATCH /me/preferences per CC-04.
 *
 * Push registration remains gated on fe-028-web-push-vapid-vs-fcm reply.
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "@linkhr/i18n";
import { PageHeader } from "@linkhr/design-system";
import { NotificationSettingsSection } from "../features/preferences/NotificationSettingsSection";
import { RouteErrorFallback } from "../components/RouteErrorFallback";

export const Route = createFileRoute("/_auth/me/preferences")({
  staticData: {
    breadcrumb: { labelKey: "me-profile:preferences.title" },
  },
  component: MePreferencesPage,
  // The channel grid resolves per-event i18n keys from a backend-driven catalog;
  // an unseeded event kind would otherwise throw in dev and blank the app. Keep
  // the failure scoped to this route's content area.
  errorComponent: RouteErrorFallback,
});

function MePreferencesPage(): JSX.Element {
  const { t } = useTranslation("me-profile");

  return (
    <section className="flex flex-col gap-lg max-w-2xl mx-auto py-md">
      <PageHeader title={t("preferences.title")} subtitle={t("preferences.subtitle")} />
      {/* Notification preferences section (D-16) — chrome refresh wraps the
          existing logic; notificationRoutingMatrix from Phase 05.1 unchanged. */}
      <NotificationSettingsSection />
      {/* Future sections: theme/density/locale toggles — Phase 6 */}
    </section>
  );
}
